import {Observable} from 'rxjs';
import {distinctUntilChanged, map, skip} from 'rxjs/operators';

import Volume from '../../Volume/Volume';

const createVolumeMutedWriteStream = (
    volumeUpdate$: Observable<Volume>
): Observable<boolean> =>
    volumeUpdate$
        .pipe(
            // Ignore the "default" emission from the volume store
            skip(1),
            map(({isMuted}) => isMuted),
            distinctUntilChanged()
        );

export default createVolumeMutedWriteStream;
